// Session booking popup — ports psychologist.js openSessionPopup + the static
// #session-payment-modal markup: "Отчёт готов" badge (when from a ready report),
// gift-offer card, benefits, then book / download-PDF / later.
// Soft-launch flow: routes to the psychologist chat (Chatwoot), no payment gate.
import styles from './Psychologist.module.css'

// Checkmark used by the badge (16px) and the feature rows (17px).
function Check({ size }: { size: number }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" width={size} height={size}>
      <path d="M20 6L9 17l-5-5" />
    </svg>
  )
}

interface SessionPopupProps {
  badge?: boolean
  text?: string
  cta?: string
  onBook: () => void
  onPdf?: () => void
  onClose: () => void
}

export default function SessionPopup({ badge, text, cta = 'Записаться на сессию', onBook, onPdf, onClose }: SessionPopupProps) {
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        {badge && (
          <span className={styles.reportReadyBadge}>
            <Check size={16} /> Отчёт готов
          </span>
        )}
        <h2>Сессия с психологом-консультантом</h2>
        <p className={styles.popupText}>
          {text || 'Психолог заранее изучит ваш отчёт о работе с ботом — встреча начнётся прямо с вашего вопроса.'}
        </p>

        <div className={styles.sessCard}>
          <div className={styles.sessPrice}>В подарок</div>
          <div className={styles.sessPriceSub}>30 минут · на платных тарифах</div>
        </div>

        <div className={styles.sessFeat}>
          <Check size={17} />
          <span>Вы можете поделиться отчётом с психологом до сессии</span>
        </div>
        <div className={styles.sessFeat}>
          <Check size={17} />
          <span>Ориентация и маршрутизация под ваш запрос</span>
        </div>

        <button className={styles.primaryBtn} onClick={onBook}>{cta}</button>
        {onPdf && <button className={styles.ghostBtn} onClick={onPdf}>Скачать отчёт (PDF)</button>}
        <button className={styles.tertiaryBtn} onClick={onClose}>Позже</button>
      </div>
    </div>
  )
}
